import { NoResultsIllustration as NoResultsIllustrationSvg } from '@eventbrite/eds-iconography';
import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { EmptyState } from './EmptyState';

const getCopyPhysical = (currentPlace: string) =>
    gettext(
        'We couldn’t find any events from this organizer in %(placeName)s. Try updating your location to find more options.',
        { placeName: currentPlace },
    );

interface NoResultsProps {
    isOrganizationsSearch: number;
    currentPlace: string;
    isOnlineSearch: boolean;
}

export const NoResults = (props: NoResultsProps) => {
    let copy = gettext(
        'Nothing matched your search, but you might like these options.',
    );

    if (props.isOrganizationsSearch) {
        copy = getCopyPhysical(props.currentPlace);

        if (props.isOnlineSearch) {
            copy = gettext(
                'We couldn’t find any online events from this organizer. Try updating your location to find more options.',
            );
        }
    }

    return (
        <EmptyState illustrationType={<NoResultsIllustrationSvg />} {...props}>
            {copy}
        </EmptyState>
    );
};
